import { Box, Typography, Link as MuiLink, SxProps } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';

const textLinkStyle: SxProps = {
  p: 0.25,
  fontSize: '16px',
  bgcolor: '#FFF',
  boxShadow: `0px 0px 8px 8px #FFF`,
  borderRadius: 0.5,
  textAlign: 'center',
  '&:hover': { color: 'primary.dark' },
  display: 'flex',
  alignItems: 'center',
  color: '#33BEB9',
  height: 24,
  pl: 0,
  py: 0.5,
  gap: 0.5,
  backgroundColor: 'transparent',
  WebkitBoxShadow: 'none',
};

export function RequireLoginContent() {
  return (
    <Box
      sx={{
        width: '100%',
        height: 'auto',
        backgroundColor: '#FAF3DC',
        display: 'flex',
        alignItems: 'center',
        padding: '12px 16px',
        gap: 1,
      }}
    >
      <LockIcon
        sx={{
          color: '#FFB300',
        }}
      />

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: 1,
        }}
      >
        <Typography variant="JP/Body/m/Regular/Normal">
          この項目は会員限定です
        </Typography>

        <MuiLink
          href={'/signup'}
          underline={'none'}
          sx={textLinkStyle}
          target="_blank"
          rel="noopener"
        >
          会員登録(無料)
        </MuiLink>
      </Box>
    </Box>
  );
}
